module.exports = __webpack_public_path__ + "assets/img/flecha-izquierda.7f575901.svg";